import FormControls from 'component/FormControls';
import Page from 'component/Page';
import { useState } from 'react';
import { Button, Form, Row } from 'react-bootstrap';
import { sendPut } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import {
	focusElement,
	getFormData,
	showConfirm,
	showToast,
	nNU
} from 'util/utils';
//import { RiEyeCloseLine } from 'react-icons/ri';
//import { ImEye } from 'react-icons/im';

// const LOGIN_ID_LIMIT_LENGTH = 16;
// const LOGIN_ID_LIMIT_LENGTH = 50;

const Register = ({ data = { id: null, valid: true }, onUpdated }) => {
  //----------------------------------HOOKS-------------------------------------------------------------

  //---------------------------------FUNCTIONS----------------------------------------------------------
  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let formData = getFormData(e.target, {
      rawCol: {
        groupName: true,
      },
    });

    if (!formData?.groupName) {
      showToast(string.APP_CHANNEL_NAME_EMPTY_ERR);
      focusElement('#groupName');
      return;
    }
		let channel = {
			groupId: data?.groupId,
			groupName: formData?.groupName,
			status: data?.status,
			type: 2,//data?.type,
			expirationDate: data?.expirationDate,
			adminId: nNU(data?.adminId) ? data?.adminId : 0,
		};

		showConfirm({
      body: string.POC_CHANNEL_UPDATE_CONFIRM,
      defaultAction: () => {
        sendPut({
          url: Urls.pocchannel.update,
          body: channel,
        }).then((res) => {
          showToast(string.POC_CHANNEL_UPDATE_SUCCESS, 'success');
          onUpdated(res);
        }).catch((e) => {
					console.log('削除エラー');
				});
      },
    });
  };

  //----------------------------------RETURN------------------------------------------------------------
  return (
    <>
      <Page
        title={string.POC_CHANNEL_UPDATE}
        body={
          <>
            <Form onSubmit={onSubmit}>
              <FormControls
                data={data}
                controls={[
                  {
                    id: 'groupName',
                    title: string.APP_CHANNEL_NAME,
                  },
                ]}
                footer={<></>}
              />
              <Row className="form-button-row">
                <Button type="submit">{string.POC_CHANNEL_SAVE}</Button>
              </Row>
            </Form>
          </>
        }
      />
    </>
  );
};

export default Register;
